'use client';

import styled from 'styled-components';

export const StyledLinks = styled.li`
  a {
    font-weight: 400;
    text-decoration: none;
    display: block;
  }
`;
